import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../styles/MyOrders.scss';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Accordion, Button, Form } from 'react-bootstrap';
import orders from '../assets/icons/orders.svg';
import UniInput, { FormControlElement } from '../components/UniInput/UniInput';
import UniPagination from '../components/UniPagination/UniPagination';
import { ResponseOrderIntentGroup, getOrderIntentGroup, getOrderIntentGroupFilter } from '../services/orderService';
import { ChangeEvent, useEffect, useState } from 'react';
import { StatusIntent } from '../types/orderIntent';
import { useUserStore } from '../store/user';
import moment from 'moment';
import { getDescriptionStatusIntent, getDescriptionStatusIntentLanguage } from '../helpers/enums';
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UniDatePickerRange from '../components/UniDatePickerRange/UniDatePickerRange';

type SearchForm = {
    search?: string,
    status?: string,
    materialCode?: string,
    tpProduct?: string,
    country?: string,
    startDate?: string,
    endDate?: string
};

const MyOrders = () => {
    const [ordersIntents, setOrders] = useState<ResponseOrderIntentGroup[]|undefined>();
    const [search, setSearch] = useState<SearchForm>();
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(true);
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItems, setTotalItems] = useState<number>();
    const [take, setTake] = useState<any>(10);
    const [page, setPage] = useState<number>(1);
    const { loginData, darkMode } = useUserStore();
    const [periodValue, setPeriodValue] = useState<string | null>('');
    const [showRangeDates, setShowRangeDates] = useState(false);
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();    
    let backToList = localStorage.getItem('backOffice_backToList');

    useEffect(() => {        
        
        if (localStorage.getItem('tkn')) 
        {
            if(backToList)
            {
                //setOrders(JSON.parse(localStorage.getItem('backOffice_orderIntents') ?? ''));
                //setTotalPages(Number(localStorage.getItem('backOffice_totalPages')));
                //setTotalItems(Number(localStorage.getItem('backOffice_totalItems')));
                let takeState = localStorage.getItem('backOffice_take');
                let pageState = Number(localStorage.getItem('backOffice_page'));                
                setPage(pageState);
                setTake(takeState);                

                if(localStorage.getItem('backOffice_search'))
                {                    
                    let searchState =JSON.parse(localStorage.getItem('backOffice_search')??'');
                    getOrders(takeState, pageState, searchState);

                    setSearch(searchState);
                }
                else
                    getOrders(takeState, pageState);

                localStorage.removeItem('backOffice_backToList');                   
            }
            else
            {                
                getOrders(take, page, search);
            }
        }            


    }, [loginData.id, take, page]);

    const getOrders = (take: any, page: number, search?: SearchForm) => {
        setLoading(true);
        setError('');
        getOrderIntentGroupFilter(
            take, 
            page, 
            search?.search ?? '', 
            search?.country ?? '', 
            search?.status ?? '', 
            search?.tpProduct ?? '',
            search?.startDate ?? '',
            search?.endDate ?? '',
        )
            .then(response => {
                if (!response.success) {
                    setError(response.error);
                }
                else {
                    setOrders(response.data);
                    setTotalItems(response.totalItems);
                    setTotalPages(response.totalPages);

                    //localStorage.setItem('backOffice_totalItems', response.totalItems.toString());
                    //localStorage.setItem('backOffice_totalPages', response.totalPages.toString());
                    localStorage.setItem('backOffice_take', take);
                    localStorage.setItem('backOffice_page', page?.toString() ?? '');
                    //localStorage.setItem('backOffice_orderIntents', JSON.stringify(response.data));                    
                    //if(search!==undefined)
                    //    localStorage.setItem('backOffice_search', JSON.stringify(search));
                    //else
                    //    localStorage.setItem('backOffice_search', '');
                    if(search)
                        localStorage.setItem('backOffice_search', JSON.stringify(search));
                }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false))
    }

    const mockDataTable = {
        headers: [
            {
                property: 'intentGroupNumber',
                name: 'Id',
                isCheck: false,
            },
            {
                property: 'customerCode',
                name: t('homeScreen.clientCode'),
                isCheck: false,
                isNumber: true
            },
            {
                property: 'customerName',
                name: t('homeScreen.client'),
                isCheck: false,
            },
            {
                property: 'materialCode',
                name: 'SKU',
                isNumber: true
            },
            {
                property: 'materialDescription',
                name: 'Material'
            },
            {
                property: 'receiverCode',
                name: t('homeScreen.receiver'),
                isNumber: true
            },
            {
                property: 'createdAt',
                name:  t('homeScreen.createdAt'),
                isDate: true
            },
            {
                property: 'lastUpdatedAt',
                name: t('homeScreen.alterAt'),
                isDate: true
            },
            {
                property: 'status',
                name: 'Status',
                isStatus: true
            },
            {
                property: 'actions',
                name: '',
                isAction: true
            },
        ]
    };

    const mockStatusStyle = [
        {
            name: StatusIntent.AnalisysUnipar,
            color: '#2C99F7',
            bgColor: '#ECF6FF',
        },
        {
            name: StatusIntent.PendingCustomer,
            bgColor: '#FFEFEA',
            color: '#FF6636',
        }
    ];

    const onChangeSearch = (e: ChangeEvent<FormControlElement>) => {
        setSearch({ ...search, search: e?.target?.value });
        //localStorage.setItem('backOffice_search', JSON.stringify({ ...search, search: e?.target?.value }));
    }

    const onChangeMaterialCode = (e: ChangeEvent<HTMLSelectElement>) => {
        setSearch({ ...search, materialCode: e?.target?.value });
        //localStorage.setItem('backOffice_search', JSON.stringify({ ...search, materialCode: e?.target?.value }));
    }

    const onChangeStatus = (e: ChangeEvent<HTMLSelectElement>) => {
        setSearch({ ...search, status: e?.target?.value });
        //localStorage.setItem('backOffice_search', JSON.stringify({ ...search, status: e?.target?.value }));
    }
    const onChangeCountry = (e: ChangeEvent<HTMLSelectElement>) => {
        setSearch({ ...search, country: e?.target?.value });
        //localStorage.setItem('backOffice_search', JSON.stringify({ ...search, country: e?.target?.value }));
    }
    const onChangeTpProduct = (e: ChangeEvent<HTMLSelectElement>) => {
        setSearch({ ...search, tpProduct: e?.target?.value });
        //localStorage.setItem('backOffice_search', JSON.stringify({ ...search, tpProduct: e?.target?.value }));
    }

    const onChangeDates = (dates: any) => {        
        const [start, end] = dates;
        setPeriodValue(dateRange(start, end));
        setSearch({ ...search, startDate: moment(start).format('yyyy-MM-DD'), endDate: moment(end).format('yyyy-MM-DD') });
    }

    const dateRange = (start: any, end: any) => {
        return moment(start).format('DD/MM/yyyy') + ' - ' + moment(end).format('DD/MM/yyyy');
    }

    const goToEdit = (id?: string) => {
        navigate('/edit-order/' + id);
    }

    // FUNCTION TO SEARCH WHEN ENTER KEY IS CLICKED
    const handleEnterKey = (event:any) => {
        if(event.key === 'Enter'){
            getOrders(take, page, search);
        }
    }

    return (
        <div className='home-wrapper'>
            <div className='my-orders-header w-100'>
                <div className='my-orders-header-i'>
                    <img src={orders} alt='icone de novo pedido' />
                    <p>{t('homeScreen.labelOrderTitle')}</p>
                </div>
            </div>
            <div className='my-orders-search w-100'>
                <div>
                    <UniInput
                        id='search'
                        placeholder={t('homeScreen.labelSearch')}
                        label={t('homeScreen.search')}
                        type='text'
                        onChangeInput={(e) => onChangeSearch(e)}
                        value={search ? search.search : ''}
                        enterKey={handleEnterKey}
                    />
                </div>
                <div>
                    <UniInput
                        id='status'
                        label='Status'
                        isSelect
                        defaultValue={'0'}
                        onChange={e => onChangeStatus(e)}
                    >                                            
                        <option value={'0'}>Todos</option>
                        {search?.status !== '1' && <option value={'1'}>{t('myOrders.labelUniparAnalysis')}</option>}
                        {search?.status === '1' && <option value={'1'} selected>{t('myOrders.labelUniparAnalysis')}</option>}
                        {search?.status !== '2' && <option value={'2'}>{t('myOrders.labelPendency')}</option>}
                        {search?.status === '2' && <option value={'2'} selected>{t('myOrders.labelPendency')}</option>}
                    </UniInput>
                </div>
                <div>
                    <UniInput
                        id='tpProduct'
                        label={t('homeScreen.groupProducts')}
                        isSelect
                        defaultValue={''}
                        onChange={e => onChangeTpProduct(e)}
                    >
                        <option value={''}>{t('homeScreen.selectAll')}</option>
                        {search?.tpProduct !== '1' && <option value={'1'}>PVC</option>}
                        {search?.tpProduct === '1' && <option value={'1'} selected>PVC</option>}
                        {search?.tpProduct !== '2' && <option value={'2'}>{t('homeScreen.chemicals')}</option>}
                        {search?.tpProduct === '2' && <option value={'2'} selected>{t('homeScreen.chemicals')}</option>}
                    </UniInput>
                </div>
                <div>
                    <UniInput
                        id='Pais'
                        label={t('user.labelCountry')}
                        isSelect
                        defaultValue={''}
                        onChange={e => onChangeCountry(e)}
                    >
                        <option value={''}>{t('homeScreen.selectAll')}</option>
                        {search?.country !== 'BR' && <option value={'BR'}>{t('user.brazil')}</option>}
                        {search?.country === 'BR' && <option value={'BR'} selected>{t('user.brazil')}</option>}
                        {search?.country !== 'AR' && <option value={'AR'}>Argentina</option>}
                        {search?.country === 'AR' && <option value={'AR'} selected>Argentina</option>}
                    </UniInput>
                </div>
                <div>
                    <UniDatePickerRange
                        loading={loading}
                        periodValue={periodValue}
                        onChange={e => onChangeDates(e)}
                        options={[]}
                        onHideChange={() => setShowRangeDates(!showRangeDates)}
                    />
                </div>
                <FontAwesomeIcon icon={faSearch} title={t('user.search')} onClick={() => getOrders(take, page, search)} />
            </div>
            <div className='w-100 d-flex justify-content-center'>
                <div className='table-uni'>
                    <div>
                        <div className='table-header'>
                            {
                                mockDataTable.headers.map(header => (
                                    <div key={header.name} style={header.isStatus ? { width: 180, textAlign: 'left' } : header.isAction ? { width: 70 } : {}} className={header.isCheck ? `check-header` : ``}>
                                        {
                                            header.isCheck ? (
                                                <>
                                                    <Form.Check
                                                        type={'checkbox'}
                                                        id={`default-check`}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    {header.name}
                                                </>
                                            )
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    {
                        loading ? (
                            <Skeleton
                                width={'100%'}
                                height={400}
                                duration={1}
                                highlightColor={darkMode ? '#6c6b6b' : '#f5f5f5'}
                                baseColor={darkMode ? '#021717' : '#ebebeb'} />
                        ) :
                            (
                                error ? (<p className='w-100 text-center p-2'>{t('customerScreen.searchNotFound')}</p>) :
                                    <Accordion as={'div'}>
                                        {
                                            ordersIntents?.map((order: any, idx) => (
                                                <Accordion.Item as={'div'} eventKey={idx.toString()} key={idx.toString()}>
                                                    <div className='item-header'>
                                                        {
                                                            mockDataTable.headers.map(header => {
                                                                if (header.isStatus) {
                                                                    return (
                                                                        <div key={header.name} style={{ maxWidth: 145 }}>
                                                                            <div className='table-status' style={{ backgroundColor: mockStatusStyle.filter(s => s.name === order.status)?.[0]?.bgColor ?? '#fff', minWidth: 145 }}>
                                                                                <span className='table-status-icon' style={{ backgroundColor: mockStatusStyle.filter(s => s.name === order.status)?.[0]?.color ?? '#fff' }}></span>
                                                                                <div className='w-100' style={{ fontSize: 11 }}>{getDescriptionStatusIntentLanguage(order?.[header.property] ?? '', i18n.language)}</div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }

                                                                if (header.property === 'check') {
                                                                    return (
                                                                        <Form.Check
                                                                            type={'checkbox'}
                                                                            id={`default-check`}
                                                                        />
                                                                    );
                                                                }

                                                                if (header.isDate) {
                                                                    return (
                                                                        <div key={header.name}>{order?.[header.property] ? moment(order?.[header.property]).format('DD/MM/yyyy') : '-'}</div>
                                                                    )
                                                                }

                                                                if (header.isNumber) {
                                                                    return (
                                                                        <div key={header.name}>{Number(order?.[header.property])}</div>
                                                                    )
                                                                }

                                                                if (header.property === 'actions') {
                                                                    return (<Button variant='outline' onClick={() => goToEdit(order?.id)} disabled={order?.status !== 1}>{t('homeScreen.editOrder')}</Button>);
                                                                }

                                                                return (
                                                                    <div key={header.name} title={order?.[header.property]}>{order?.[header.property] ? order?.[header.property]?.length > 10 ? order?.[header.property]?.slice(0, 9) + '...' : order?.[header.property] : '-'}</div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </Accordion.Item>
                                            ))
                                        }
                                    </Accordion>
                            )
                    }
                </div>
            </div>
            {
                <UniPagination totalItems={totalItems} totalPages={totalPages} currentPage={page} currentTake={take} changePage={(e) => setPage(e)} changeTake={(e) => { setPage(1); setTake(e) }} />
            }
        </div>
    );
}

export default MyOrders;